import { Record } from 'immutable';
export default Record([{
  background: 'transparent',
  color: 'gray'
}]);